<template>
  <div>
    <v-dialog v-model="value" persistent max-width="600px" scrollable>
      <v-card>
        <v-card-title class="headline gradiente lighten-2 elevation-3">
          <span class="white--text">{{ title }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap row justify-center>
              <v-flex xs6 sm3>
                <v-img
                  :src="require('@/assets/panel/devices/ico_sync.png')"
                ></v-img>
              </v-flex>
              <v-flex :ml-5="!$vuetify.breakpoint.xsOnly" xs12 sm5>
                <p>{{ $t('devices.permissions') }}</p>
                <v-checkbox
                  v-model="permitForm.selected"
                  v-for="p in permits"
                  :key="p.id"
                  :label="translatePermits(p.name)"
                  :value="p.name"
                  color="primary"
                  :error-messages="permitsErrors"
                  @change="changeOnDelivery($event, p.name)"
                />
                <div
                  class="ml-3 pa-3 box_doors"
                  v-show="permitForm.selected.some((e) => e === 'Delivery')"
                >
                  <div
                    style="
                      display: flex;
                      justify-content: start;
                      align-items: center;
                      height: 30px;
                    "
                  >
                    <v-label
                      class="c_label"
                      style="display: flex; align-items: center"
                      ripple
                      @click="toggleAll"
                    >
                      <v-icon
                        class="mr-1"
                        :color="selectedDoors.length > 0 ? 'primary' : ''"
                      >
                        {{ iconDoors }}
                      </v-icon>
                      Todos
                    </v-label>
                  </div>
                  <v-tooltip v-for="door in possibleDoors" bottom>
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        <v-checkbox
                          class="ma-0 pa-0 c_label"
                          style="height: 30px"
                          v-model="selectedDoors"
                          :label="door.doorName"
                          :value="door.id"
                          color="primary"
                        />
                      </div>
                    </template>
                    <span>{{ door.doorName }}</span>
                  </v-tooltip>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="working.w" flat @click="close">
            {{ $t('generic.cancel') }}
          </v-btn>
          <v-btn
            :disabled="working.w"
            color="primary darken-1"
            flat
            @click="deviceCopy == null ? create() : update()"
          >
            {{ $t('generic.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <loading v-model="working.w" text="Trabajando..."></loading>
    <success v-model="toast.success" text="Creación Exitosa"></success>
    <error v-model="toast.failed" text="Ups ocurrió un error"></error>
  </div>
</template>

<script>
import error from '../Dialogs/Error.vue'
import loading from '../Dialogs/Loading.vue'
import success from '../Dialogs/Success.vue'
export default {
  components: {
    loading,
    success,
    error,
  },
  props: ['value', 'title', 'device'],
  validations: {
    permitForm: {
      selected: {
        onlyOne() {
          return this.permitForm.selected.length > 0 ? true : false
        },
      },
    },
  },
  mounted() {
    this.getPermits()
    this.getDoors()
  },
  // filters: {
  //   translatePermits(value) {
  //     var permit = ''
  //     if (value == 'Face_Register') {
  //       permit = 'Registro facial'
  //     }
  //     if (value == 'Face_Attendance') {
  //       permit = 'Módulo de asistencia por reconocimiento facial'
  //     }
  //     if (value == 'Manual_Attendance') {
  //       permit = this.$t('devices.access_control')
  //     }
  //     if (value == 'Delivery') {
  //       permit = this.$t('devices.exit_control')
  //     }
  //     return permit
  //   },
  // },
  watch: {
    selectedDoors() {
      if (
        this.selectedDoors.length === 0 &&
        this.permitForm.selected.includes('Delivery')
      ) {
        this.permitForm.selected = this.permitForm.selected.filter(
          (e) => e !== 'Delivery'
        )
      }
    },
    device() {
      this.deviceCopy = this.device
      this.permitForm.selected = this.deviceCopy.permits.map((e) => e.name)
      this.selectedDoors = this.deviceCopy.doors.map((e) => e.id)
    },
  },
  data: () => ({
    deviceCopy: undefined,
    possibleDoors: [],
    selectedDoors: [],
    permitForm: {
      selected: [],
    },
    working: {
      w: false,
    },
    toast: {
      success: false,
      failed: false,
    },
    permits: [],
  }),
  methods: {
    changeOnDelivery(e, name) {
      if (name !== 'Delivery') return

      if (e.includes('Delivery')) {
        this.selectedDoors = this.possibleDoors.map((e) => e.id)
      } else {
        this.selectedDoors = []
      }
    },
    getDoors() {
      this.$store
        .dispatch('level/getLevelsTools')
        .then((response) => {
          this.possibleDoors = response.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    translatePermits(value) {
      var permit = ''
      if (value == 'Face_Register') {
        permit = 'Registro facial'
      }
      if (value == 'Face_Attendance') {
        permit = 'Módulo de asistencia por reconocimiento facial'
      }
      if (value == 'Manual_Attendance') {
        permit = this.$t('devices.access_control')
      }
      if (value == 'Delivery') {
        permit = this.$t('devices.exit_control')
      }
      return permit
    },
    close() {
      this.deviceCopy = undefined
      this.selectedDoors = []
      this.permitForm.selected = []
      this.$v.$reset()
      this.$emit('input', !this.value)
    },
    getPermits() {
      this.$store
        .dispatch('employee/getPermits')
        .then((response) => {
          this.permits = response.data.entity
        })
        .catch((error) => {
          console.log(error)
        })
    },
    create() {
      this.$v.permitForm.$touch()
      if (!this.$v.$invalid) {
        this.working.w = true

        this.$store
          .dispatch('employee/genQrCode', this.getBody())
          .then((response) => {
            this.working.w = false
            this.toast.success = true
            this.$emit('request', response.data)
            this.close()
          })
          .catch((error) => {
            this.working.w = false
            this.toast.failed = true
            console.log(error)
          })
      }
    },
    toggleAll() {
      if (this.selectedDoors.length) this.selectedDoors = []
      else this.selectedDoors = this.possibleDoors.map((e) => e.id).slice()
    },
    getBody() {
      return {
        doors: this.selectedDoors.length !== 0 ? this.selectedDoors : undefined,
        permits: this.permitForm.selected,
      }
    },
    update() {
      this.$v.permitForm.$touch()
      if (!this.$v.$invalid) {
        this.working.w = true

        this.$store
          .dispatch('employee/updatePermits', {
            deviceId: this.deviceCopy.id,
            body: this.getBody(),
          })
          .then((response) => {
            this.working.w = false
            this.toast.success = true
            this.$emit('edited', response)
            this.close()
          })
          .catch((error) => {
            this.working.w = false
            this.toast.failed = true
            console.log(error)
          })
      }
    },
  },

  computed: {
    selectAllDoors() {
      return this.selectedDoors.length === this.possibleDoors.length
    },
    selectSomeDoors() {
      return this.selectedDoors.length > 0 && !this.selectAllDoors
    },
    iconDoors() {
      if (this.selectAllDoors) return 'disabled_by_default'
      if (this.selectSomeDoors) return 'indeterminate_check_box'
      return 'check_box_outline_blank'
    },
    permitsErrors() {
      const errors = []
      if (!this.$v.permitForm.selected.$dirty) return errors
      !this.$v.permitForm.selected.onlyOne &&
        errors.push('Debes seleccioanr al menos un permiso')
      return errors
    },
  },
}
</script>

<style scoped>
.c_label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.box_doors {
  border: 1px solid #e6e6e6;
  border-radius: 6px;
  margin-left: 40px;
  height: 120px;
  min-height: 120px;
  overflow: scroll;
}
</style>
